<script>
import Header from '@/components/global/FeatureComponents/Header/web.vue'

/**
 * MY Career 页面自定义 Header
 *
 * 复用原有 Header/web.vue 的全部模板和逻辑，
 * 仅覆盖 logo 跳转链接和 site-nav 导航数据。
 */

import { CAREER_NAV_LINKS } from '~/common/careerRoutes'

// 自定义 logo 跳转链接
const CAREER_LOGO_JUMP_URL = '/career'

export default {
  name: 'MyCareerHeader',
  extends: Header,
  computed: {
    // 覆盖 store 中的 navigationLinks，使用自定义 career 导航数据
    navigationLinks() {
      return CAREER_NAV_LINKS
    },
  },
  methods: {
    // 覆盖 mixin 中的 getsiteJumpUrl，使用自定义 logo 跳转链接
    getsiteJumpUrl() {
      this.siteJumpUrl = CAREER_LOGO_JUMP_URL
    },
    // Career 页面始终使用 double 布局（上下两排），不受 store 中 headerType 影响
    querySiteHeaderType() {
      this.realHeaderType = 'double'
    },
  },
}
</script>
